module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/print-ticket-v2/print-ticket-v2.component.scss
// module id = ./src/app/modules/common-module/components/print-ticket-v2/print-ticket-v2.component.scss
// module chunks = 9